import type { PantryIntakeItem, PantryIntakeMode } from "@batch-and-bowl/shared";
import { apiFetch, ApiError } from "./client";

// Multipart — bypasses apiFetch's forced JSON content-type (same pattern as
// recipe-import.ts's extractRecipeFromImage and ImageUpload).
export async function extractPantryIntake(
  file: File,
  mode: PantryIntakeMode,
): Promise<PantryIntakeItem[]> {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("mode", mode);
  const response = await fetch("/api/backend/pantry/intake", {
    method: "POST",
    body: formData,
    credentials: "include",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new ApiError(data.error || "Pantry scan failed", response.status, data);
  }
  return (data as { items: PantryIntakeItem[] }).items;
}

/**
 * Barcode lookup (Pantry v2, B4, issue #376). A plain JSON POST -- unlike
 * extractPantryIntake above, there's no file to upload, so this goes
 * through the normal apiFetch wrapper rather than a bespoke fetch call.
 * Returns the same `PantryIntakeItem[]` shape (always exactly one item) so
 * PantryIntake.tsx can feed it through the SAME toReviewRows/review-card
 * path the photo-scan flow uses.
 */
export async function lookupPantryItemByBarcode(upc: string): Promise<PantryIntakeItem[]> {
  const data = await apiFetch<{ items: PantryIntakeItem[] }>("/pantry/intake/barcode", {
    method: "POST",
    body: JSON.stringify({ upc }),
  });
  return data.items;
}
